var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSketchLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "w-auto mx-auto h-auto block Sketch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(.17 30.901)",
    fill: "#EA6C00"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 94.64 30.901)",
    fill: "#EA6C00"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(19.3 30.901)",
    fill: "#FDAD00"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "translate(19.3 .42)",
    fill: "#FDD231"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(-1 0 0 1 75.5 .42)",
    fill: "#FDD231"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "matrix(-1 0 0 1 94.64 3.234)",
    fill: "#FDAD00"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "translate(.17 3.234)",
    fill: "#FDAD00"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "translate(19.3 .42)",
    fill: "#FEEEB7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fillRule: "evenodd",
    d: "M19.131 0l28.1 55L0 0h19.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    fillRule: "evenodd",
    d: "M19.131 0l28.1 55L0 0h19.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fillRule: "evenodd",
    d: "M0 0h56.2L28.1 55 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    fillRule: "evenodd",
    d: "M28.1 0L1.479 2.814 0 30.481 28.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    fillRule: "evenodd",
    d: "M28.1 0L1.479 2.814 0 30.481 28.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fillRule: "evenodd",
    d: "M0 27.667L20.61 0l-1.479 27.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    fillRule: "evenodd",
    d: "M0 27.667L20.61 0l-1.479 27.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fillRule: "evenodd",
    d: "M28.1 0L0 30.481h56.2L28.1 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchLogo);
export default __webpack_public_path__ + "static/media/SketchLogo.e9c90f3b.svg";
export { ForwardRef as ReactComponent };